import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardType } from '@models/card.model';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'lgb-stats-card',
  imports: [
    UiModule,
    RouterModule
  ],
  templateUrl: './stats-card.html',
  styleUrl: './stats-card.css',
})
export class StatsCard {
  //service
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);
  readonly globalS=inject(Global);

  //data
  readonly type=signal<CardType>(null);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    this.route.paramMap
      .pipe(
        switchMap(params => this.globalS.getType(params.get('type')))
      )
      .subscribe(type => {
        this.type.set(type);
        this.loading.set(false);
      });
  }
}
